import { BoardAuthorHOC } from '../../../Author/hocs/BoardAuthorHOC/BoardAuthorHOC';
import { BoardStarredButtonHOC } from '../../../StarredButton/hocs/BoardStarredButtonHOC/BoardStarredButtonHOC';
import { ArchiveHOC } from '../../../Archive/hocs/ArchiveHOC/ArchiveHOC';
import { BoardNameHOC } from '../../../BoardName/hocs/BoardNameHOC/BoardNameHOC';
import { BoardDescriptionHOC } from '../../../BoardDescription/hocs/BoardDescriptionHOC/BoardDescriptionHOC';
import * as React from 'react';
import { CLASS_BOARD_DETAILS } from '../../../../constants';
import { IInfoProps } from './types';
import './_Info.scss';

export const Info = ({
    boardId,
    isReadonly,
}: IInfoProps) => {
    const className = CLASS_BOARD_DETAILS + '-info';
    return <div className={className}>
        <div className={className + '__author-and-starred'}>
            <BoardAuthorHOC boardId={boardId} />
            <BoardStarredButtonHOC boardId={boardId} />
            <ArchiveHOC boardId={boardId} />
        </div>
        <div className={className + '__title'}>
            <BoardNameHOC boardId={boardId} isReadonly={isReadonly} />
            <BoardDescriptionHOC boardId={boardId} />
        </div>
    </div>;
}
